// Site Configurations for Shop Marriott
// -- These values are unique for each site and rarely need to be changed after initial setup
// -- They are passed to the coreContext in _app.tsx and can be accessed in hah-fe-core via the useContext hook

import type { RumConfig } from '@Hotels-at-Home/hah-fe-core/dist/hooks/useRumScript';

export const csrEmail = 'customer.service@stregisboutique.com';
export const siteName = 'St. Regis Boutique'; // Used in meta tags, for copy interpolation, etc.
export const parentHotelCompany = 'Marriott';
export const hotelBrandName = 'St. Regis';
export const catalogId = 'STR';
export const region = 'EU';
export const scandiWebMenuId = 'streu';
export const companyTelephone = '+33 1 41 51 51 54 ';

export const LOGO_IMAGE = { src: '/images/misc/st-regis-boutique-logo.svg', alt: '' };

// Product/Category Page Settings
// - imageWidth/imageHeight set the size of the <img /> on cat/prod pages to prevent layout shift
export const product = {
  imageWidth: 719,
  imageHeight: 570,
  imageWidthThumbnail: 500,
  almaWidget: true,
};

export const category = {
  imageEagerLoadingAmount: 3,
};

export const cart = {
  counterButtons: true,
  drawerContinueShopping: false,
  useCartDrawer: true,
  staticQuantity: true,
  ymalName: 'STREU - Cart',
  disableCartYmals: true,
  drawerTotalInBUtton: false,
};

export const checkout = {
  placeholderLabels: true,
  radioButtons: true,
  paymentMethodProceedButton: true,
};

export const header = {
  leftDrawerUtilities: true,
};

// Misc
export const firstVisitModal = {
  modalWidth: 555,
};

// Adobe Launch Settings
// - Remove these lines completely if this is not a Marriott site
export const enableBonvoyNumber = true;
export const enableMarriottAdobeLaunch = true;
export const enableBonvoyLoyaltyProgramme = true;
export const account = {
  disableAccountDrawer: false,
  enableWelcomeMessage: true,
};
export const marriottAdobeLaunchBrandCode = 'XR';
export const marriottAdobeLaunchBrandName = 'Marriott Hotels & Resorts';

// Google Tag Manager & Analytics Settings
export const enableGoogleTagManager = true;
export const googleTagManagerId = 'GTM-WC44FFK';
export const productNameFilters = {
  replacements: [{ target: 'The Marriott', replacement: 'Marriott' }],
  splits: [{ split: ' - ', keepIndex: 0 }],
};

// CloudWatch RUM (Real User Monitoring)
// Loaded by useRumScript hook in App.tsx, gated on ConsentMode.analytics
// (OneTrust via Adobe Launch).
// AppMonitor ID and identity pool ID are public identifiers (they ship in the client
// bundle); see cloudwatch-rum-gdpr-investigation.md in hah-docs for rationale.
export const cloudWatchRum: RumConfig = {
  applicationId: 'ed8b9d29-eb2b-4228-a0c1-6a388e1296bf',
  region: 'eu-central-1',
  identityPoolId: 'eu-central-1:9a1b3829-11c8-4a06-b474-df9fd49dc0d1',
};

// Cookie Restorer for Safari ITP
export const cookieRestorerEnabled = true;
export const cookieRestorerOptions = { options: { interval: 5000 } };

// Meta Tags
export const googleSiteVerification = 'PpFOm5_SFHwxWgwxs3R1l9YyuIGRB3cWZD1unjO_0i0';
export const defaultOgImage = '/images/homepage/heroSection/st-regis-frette-hp-mob.jpg';

// Links to international sites
export const INTL_SITES = [
  {
    region: 'NA',
    links: [{ value: 'U.S.A.', url: 'https://shop.marriott.com/brands/st-regis.html?referrer=eu' }],
  },
  {
    region: 'APAC',
    links: [
      { value: 'English', url: 'https://www.stregisboutique.cn/en/?___store=strcn_en' },
      { value: '简体中文', url: 'https://www.stregisboutique.cn/zh-CN/?___store=strcn_zh' },
    ],
  },
];

export const zendeskKey = 'f03e789e-765d-40e6-8986-720a604bbf34';
